<template>
  <b-row class="mx-0 mb-2 p-0" v-if="isLocked">
    <b-col cols="12" class="px-0">
      <b-alert
        show
        variant="warning"
        class="d-flex align-items-center mb-0"
      >
        <i
          class="fas fa-exclamation-triangle mr-2"
          style="font-size: 1.1rem"
        ></i>
        <div class="flex-grow-1">
          <strong>Hóa đơn trả hàng đã có hóa đơn GTGT điều chỉnh.</strong>
           Các trường hợp chỉnh sửa cần liên hệ kế toán để được hỗ trợ.
          <template v-if="adjustmentEinvoice.invoiceNo">
            <span class="mx-2">|</span>
            Số HĐ điều chỉnh: <strong>{{ adjustmentEinvoice.invoiceNo }}</strong>
          </template>
          <template v-if="issuedAtDisplay">
            <span class="mx-2">|</span>
            Ngày phát hành: {{ issuedAtDisplay }}
          </template>
        </div>
        <AdjustmentEInvoiceStatusBadge
          class="ml-2"
          size="sm"
          :status="adjustmentEinvoice.status"
          :invoice-no="adjustmentEinvoice.invoiceNo"
          :pattern="adjustmentEinvoice.pattern"
          :serial="adjustmentEinvoice.serial"
          :issued-at="adjustmentEinvoice.issuedAt"
          :tax-status="adjustmentEinvoice.taxStatus"
          :error-message="adjustmentEinvoice.errorMessage"
          :draft-code="adjustmentEinvoice.draftCode"
        />
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
  import moment from 'moment'
  import AdjustmentEInvoiceStatusBadge from '@/view/components/bills/AdjustmentEInvoiceStatusBadge.vue'

  export default {
    name: 'BillAdjustmentEInvoiceLockAlert',
    components: { AdjustmentEInvoiceStatusBadge },
    props: {
      adjustmentEinvoice: {
        type: Object,
        default: null,
      },
    },
    computed: {
      isLocked() {
        return Boolean(this.adjustmentEinvoice && this.adjustmentEinvoice.status)
      },
      issuedAtDisplay() {
        const issuedAt = this.adjustmentEinvoice && this.adjustmentEinvoice.issuedAt
        if (!issuedAt) return ''
        const m = moment(issuedAt)
        return m.isValid() ? m.format('DD/MM/YYYY') : ''
      },
    },
  }
</script>
